export const SET_SNACKBAR = 'SET_SNACKBAR'
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR'
export const SET_WINDOW_SIZES = 'SET_WINDOW_SIZES'
export const SET_PREV_PAGE = 'SET_PREV_PAGE'
export const SET_SIDEBAR_STATE = 'SET_SIDEBAR_STATE'
export const CLOSE_COOKIES_SNACKBAR = 'CLOSE_COOKIES_SNACKBAR'
